<template>
  <div id="app">
    <div v-if="globalLoading && !hasError" class="el-section el-centered eu-align-items_center">
      <emd-pagarme-loader class="fade-in" :color="'secondary'" />
    </div>
    <global-error v-if="!globalLoading && hasError" :showLogo="false" :code="globalErrorCode" :theme="theme"/>
    <template v-else-if="!globalLoading && !hasError">
      <router-view />
    </template>
  </div>
</template>
<script>
import { GlobalError, EmdPagarmeLoader } from 'emerald-vue/src/components'
import { page as appcuesPage } from './vendor/appcues'
import { toStoneBrand } from '@/utils/stone-rebrand.utils'

export default {
  name: 'App',
  components: {
    GlobalError,
    EmdPagarmeLoader
  },
  computed: {
    pref () {
      return this.$store.getters.pref
    },
    hasError () {
      return this.$store.getters.globalError
    },
    globalLoading () {
      return this.$store.getters.globalLoading
    },
    globalErrorCode () {
      return this.$store.getters.globalErrorCode
    },
    account () {
      return this.$store.getters.accountData
    },
    appVersion () {
      return this.$store.state.appVersion
    },
    theme () {
      return process.env.VUE_APP_THEME
    }
  },
  methods: {
    setLanguage () {
      const preferences = Object.assign({}, JSON.parse(JSON.stringify(this.pref)))
      preferences.language = this.$i18n.locale
      this.$store.dispatch('SET_PREFERENCES', preferences)
    }
  },
  mounted () {
    var meta = document.createElement('meta')
    meta.name = 'version'
    meta.content = this.appVersion
    document.getElementsByTagName('head')[0].appendChild(meta)
  },
  watch: {
    $route (to, from) {
      appcuesPage()
      this.$nextTick().then(() => {
        document.title = `${this.account.name} | ${this.$t(
          to.meta.title
        )} - ${toStoneBrand(process.env.VUE_APP_TITLE)}`
      })
    }
  },
  beforeMount: function () {
    this.$i18n.locale = this.pref.language
    this.setLanguage()

    const body = document.body

    this.$store.dispatch('GET_PREFERENCES').then(() => {
      const preferences = Object.assign({}, JSON.parse(JSON.stringify(this.pref)))
      if (preferences.appearance.mode === 'light') {
        body.classList.remove('_mode_dark')
      } else {
        body.classList.add('_mode_dark')
      }
      this.$store.dispatch('SET_PREFERENCES', preferences)
    })
  }
}
</script>

<style>
#atlwdg-trigger {
  background: var(--brand--le--primary-color--base);
  color: #fff !important;
  border: none;
  box-shadow: none;
  border-radius: 4px 0 0 0;
  text-transform: uppercase;
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  font-size: 11px;
  padding: 6px 12px;
}
</style>
